import { defineMessages } from 'react-intl';

export default defineMessages({
  heading: {
    id: 'app.components.ErrorState.heading',
    defaultMessage: 'Oh no…',
  },
  accountError: {
    id: 'app.components.ErrorState.accountError',
    defaultMessage: 'There was an error loading your account.',
  },
  profileError: {
    id: 'app.components.ErrorState.profileError',
    defaultMessage: 'There was an error loading your profile.',
  },
  javascriptError: {
    id: 'app.components.ErrorState.javascriptError',
    defaultMessage: "We're sorry — something's gone wrong.",
  },
  errorHelp: {
    id: 'app.components.ErrorState.errorHelp',
    defaultMessage: 'Please try {reloading} or contact us at {email}.',
  },
  errorHelpReloading: {
    id: 'app.components.ErrorState.errorHelpReloading',
    defaultMessage: 'reloading the page',
  },
  debugInformation: {
    id: 'app.components.ErrorState.debugInformation',
    defaultMessage:
      'Error Information | Account: {subdomain} | User Agent: {userAgent}',
  },
});
